module.exports = __webpack_public_path__ + "img/DAY3-2.e13bee78.jpg";